import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Avatar,
  Box,
  Typography
} from '@mui/material';
import {
  School as StudentIcon,
  SupervisorAccount as CoordinatorIcon,
  AdminPanelSettings as AdminIcon
} from '@mui/icons-material';

const RoleSelector = ({ open, email, roles, onSelectRole, onClose }) => {
  const getRoleIcon = (role) => {
    switch (role) {
      case 'student':
        return <StudentIcon />;
      case 'coordinator':
        return <CoordinatorIcon />;
      case 'admin':
        return <AdminIcon />;
      default:
        return <StudentIcon />;
    }
  };

  const getRoleColor = (role) => {
    switch (role) {
      case 'student':
        return '#1976d2';
      case 'coordinator':
        return '#9c27b0';
      case 'admin':
        return '#d32f2f';
      default:
        return '#1976d2';
    }
  };

  const getRoleTitle = (role) => {
    return role.charAt(0).toUpperCase() + role.slice(1);
  };

  const getRoleDescription = (role) => {
    switch (role) {
      case 'student':
        return 'Access your classes, content, and schedule';
      case 'coordinator':
        return 'Manage batches and coordinate activities';
      case 'admin':
        return 'Full system administration';
      default:
        return '';
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography variant="h5" fontWeight={600}>
          Select Your Role
        </Typography>
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 3 }}>
          You have multiple accounts with <strong>{email}</strong>. Please select how you'd like to sign in:
        </DialogContentText>
        <List>
          {roles.map((roleData) => (
            <ListItem key={roleData.role} disablePadding sx={{ mb: 1 }}>
              <ListItemButton
                onClick={() => onSelectRole(roleData.role)}
                disabled={!roleData.is_active || !roleData.is_approved}
                sx={{
                  borderRadius: 2,
                  border: '2px solid',
                  borderColor: getRoleColor(roleData.role),
                  '&:hover': {
                    backgroundColor: `${getRoleColor(roleData.role)}15`,
                  },
                }}
              >
                <ListItemIcon>
                  <Avatar
                    sx={{
                      bgcolor: getRoleColor(roleData.role),
                      width: 48,
                      height: 48,
                    }}
                  >
                    {getRoleIcon(roleData.role)}
                  </Avatar>
                </ListItemIcon>
                <ListItemText
                  primary={
                    <Typography variant="h6" fontWeight={600}>
                      {getRoleTitle(roleData.role)}
                    </Typography>
                  }
                  secondary={
                    <Box>
                      <Typography variant="body2" color="text.secondary">
                        {getRoleDescription(roleData.role)}
                      </Typography>
                      {(!roleData.is_active || !roleData.is_approved) && (
                        <Typography variant="caption" color="error" sx={{ mt: 0.5, display: 'block' }}>
                          {!roleData.is_active && 'Account inactive'}
                          {!roleData.is_approved && 'Pending approval'}
                        </Typography>
                      )}
                    </Box>
                  }
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </DialogContent>
    </Dialog>
  );
};

export default RoleSelector;
